import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ClientLogo from './ClientLogo';
import ReactSVG from 'react-svg';
import HeaderMenu from './HeaderMenu';
import commonUI from "../utils/commonUI.jsx";

const Header = ({className, isSummaryPage, showContactForm }) => {
    const componentClass = 'header';
    const classes = classnames(
        'header',
        className
    );

    const [showHeaderMenu, setShowHeaderMenu] = useState(false);

    return <header className={classes}>
        <div className='container'>
            <div className={`${componentClass}__logo`}>
                <ClientLogo useWhiteLogo />
            </div>
            {isSummaryPage && <div className={`${componentClass}__decoration`}>
                <ReactSVG src={'/classpath/assets/images/waves.svg'}/>
            </div>}
            {isSummaryPage && !showHeaderMenu && <button className={`${componentClass}__header-menu`} onClick={() => setShowHeaderMenu(true)}>
                <ReactSVG src={'/classpath/assets/images/hamburguer-icon.svg'}/>
            </button>}
            {isSummaryPage && showHeaderMenu && <button className={`${componentClass}__header-menu--close`} onClick={() => setShowHeaderMenu(false)}>
                {commonUI.closeButton}
            </button>}
            {showHeaderMenu && <HeaderMenu showContactForm={showContactForm}/> }
        </div>
    </header>;
};

Header.propTypes = {
    className: PropTypes.string
};

export default Header;
